<!--
Product List

Displays a list of products.
-->

<template>
  <div class="product-list-wrapper"  :class="{ 'bg-light py-3' : !isFullscreen}">
    <div class="product-list rounded mx-n2 bg-white" :class="{ 'shadow-sm' : !isFullscreen}">
      <div class="product-card media align-items-center container-fluid"
        :class="isFullscreen? 'py-2' : 'py-3' "
        v-for="product in products"
        v-bind:key="product.id">
        <div class="thumbnail"
             :class="isFullscreen? 'mr-2' : 'mr-3' ">
          <img v-bind:src="product.image_link">
        </div>
        <div class="media-body">
          <div class="product-name text-truncate">
              {{ product.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

/**
 * Product List
 *
 * This is used to display products associated with the current application
 */
export default {
  name: 'ProductList',
  props: {
    /**
     * The ID for the application this product list is related to. Used to fetch
     * the product information
     */
    applicationId: String,
  },
  methods: {
    /**
     * Gets product data associated with the current application form
     * from RRAPI backend
     */
    getProducts() {
      this.$store.dispatch(
        'products/fetchProductData',
        this.applicationId,
      );
    },
  },
  computed: mapState({
    products: state => state.products.products,
    isFullscreen() {
      return (/true/).test(this.$route?.query.fullScreen);
    },
  }),
  created() {
    this.getProducts();
  },
};
</script>
